<template>
    <audio controls :src="url" />
  </template>
  <script>
  export default {
    props: ['url']
  }
  </script>